module.exports = __webpack_public_path__ + "img/logo-jxspf.81faf37f.png";